<template>
  <div >
    <div v-if="!isSubMenu">
      <v-list>
        <div v-for="(data, idx) in navigation" :key="idx">
          <v-list-item @click="redirectReload(data.router)" v-if="data.router">
            <v-list-item-title style="font-family: Poppins; font-weight: bold;">
              {{ $t(data.textKey) }}
            </v-list-item-title>
          </v-list-item>

          <v-list-group no-action v-else>
            <template v-slot:activator>
              <v-list-item-title style="font-family: Poppins; font-weight: bold;">{{ $t(data.textKey)
              }}</v-list-item-title>
            </template>

            <v-list-item v-for="(data2, idx2) in data.items" :key="idx2" @click="redirectReload(data2)" >
              <v-list-item-title style="display: flex; justify-content: space-between;margin-left: -40px;">
                {{ $t(data2.nameKey) }} <Arrow direct="right" v-if="data2.router === ''" width="16" height="16" />
              </v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
      <div class="container-lang">
        <div class="lang-ctn" @click="setLanguage('id')">
          <v-radio-group v-model="$i18n.locale" class="language-option" dense>
            <v-radio value="id"></v-radio>
          </v-radio-group>
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <img src="@/assets/icons/idn-flag.png" style="border-radius: 6px;" alt="IDN" width="25" height="20" />
              <span class="ml-2">ID</span>
            </div>
          </div>
        </div>
        <div>
          <div class="lang-ctn-line"></div>
        </div>
        <div class="lang-ctn" @click="setLanguage('en')">
          <v-radio-group v-model="$i18n.locale" class="language-option" dense>
            <v-radio value="en"></v-radio>
          </v-radio-group>
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center">
              <img src="@/assets/icons/eng-flag.png" style="border-radius: 6px;" alt="ENG" width="25" height="20" />
              <span class="ml-2">EN</span>
            </div>
          </div>
        </div>
      </div>
      <div style="width:90%; margin: 20px auto;">
        <v-btn depressed color="#162CA2" @click="redirectReload('/login')" style="width: 100%;" class="btn-radius">
          <span class="text-capitalize font-weight-bold" style="color:#FFFFFF">{{ $t('navbarLogIn') }}</span>
        </v-btn>
      </div>
    </div>
    <div v-else>
      <div class="sub-menu-header" >
        <div class="d-flex align-center" style="margin-bottom: 30px;" @click="closeSubMenu">
            <Arrow direct="left" width="20" height="20" /> 
            <span style="padding-left: 10px;">Kembali</span>
        </div>
        <div v-for="(i, menu) in navigation" :key="menu">
          <div v-if="i.key === 'programs'">
              <h3 class="sub-menu-title">{{titleSubMenu}}</h3>
              <p class="sub-menu-description">{{ descSubMenu }}</p> 
              <div v-for="(a, submenu) in i.items" :key="submenu">
                <div v-if="titleSubMenu === a.text">
                  <div class="sub-menu-label" v-for="(c, classData) in a.classes" :key="classData">
                    <div @click="navigate(c.router+c.slug_name)">
                      {{ c.name }}
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from '../assets/icons/Arrow2.vue';

export default {
  components: {
    Arrow,
  },
  data() {
    return {
      isSubMenu: false,
      titleSubMenu: "Bootcamp",
      descSubMenu: "Digital acceleration program yang dirancang intensif untuk talent siap kerja.",
      navigation: [
        {
          textKey: "navbarPrograms",
          key: "programs",
          items: [
            { text: "Bootcamp", nameKey: "navbarBootcamp", router: "", desc: "Digital acceleration program yang dirancang intensif untuk talent siap kerja.",
              classes: [{
                id: 1,
                name: "Fullstack Web Development with Integration AI",
                slug_name: "fullstack-web-development-with-integration-ai",
                // fullstack-web-development-with-integration-ai
                router: "/class/bootcamp/",
              }],
             },
            { text:"Sertifikasi", nameKey: "navbarCorporateAcceleration", router: "", desc: "Digital acceleration program yang dirancang intensif untuk talent siap kerja dan mendapakan sertifikasi global sesuai bidang tertentu.",
              classes: [
                {
                  id: 1,
                  name: "Certified Big Data by Alicloud",
                  slug_name: "pelatihan-dan-sertifikasi-big-data-alibaba-cloud",
                  // certified-big-data-by-alicloud
                  router: "/certification/detail/",
                },
                {
                  id: 2,
                  name: "Certified Cloud Computing by Alicloud",
                  slug_name: "alibaba-cloud-computing-certification",
                  // certified-cloud-computing-by-alicloud
                  router: "/certification/detail/",
                },
                {
                  id: 3,
                  name: "Certified Junior Coder by BNSP",
                  slug_name: "junior-coder",
                  // certified-junior-coder-by-bnsp
                  router: "/certification/detail/",
                },
                {
                  id: 4,
                  name: "Certified Junior Web Developer by BNSP",
                  slug_name: "junior-web-programmer",
                  // certified-junior-web-developer-by-bnsp
                  router: "/certification/detail/",
                }]
              },
            { nameKey: "navbarWebinar", router: "/event" },
          ],
        },
        {
          textKey: "navbarForCorporate",
          key: "corporate",
          items: [
            { nameKey: "navbarCollaborationPartner", router: "/corporate/collaboration" },
            { nameKey: "navbarCorporateTraining", router: "/corporate/training" },
            { nameKey: "navbarTalentAsAService", router: "/corporate/talent-service" },
            { nameKey: "navbarTechnologyService", router: "/corporate/services" },
          ],
        },
        {
          textKey: "navbarDigitalInsight",
          key: "digitalInsight",
          items: [
            { nameKey: "navbarArticles", router: "/blog" },
          ],
        },
        {
          textKey: "navbarWhyHiColleagues",
          key: "whyHiColleagues",
          items: [
            { nameKey: "navbarAboutUs", router: "/about" },
            { nameKey: "navbarPortfolio", router: "/portfolio" },
            { nameKey: "navbarTestimony", router: "/testimony" },
          ],
        },
      ],
    }
  },
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang;
      sessionStorage.setItem("bahasa", lang);
      this.$emit('close', {});
    },
    redirectReload(e) {
      if(e.router != "") {
        this.$router
          .push({ path: e.router})
          .then(() => { this.$router.go() });
      } else {
        this.isSubMenu = true
        this.titleSubMenu = e.text;
        this.descSubMenu = e.desc
      }
    },
    navigate(e) {
      if(e != ""){
        window.location.href = e;
      }
    },
    closeSubMenu() {
      this.isSubMenu = false
    },
    navigateReload(e) {
      this.$router
        .push({ path: e })
        .then(() => { this.$router.go() });
    },
  }
}
</script>

<style scoped>
.language-selector {
  display: flex;
  align-items: center;
  margin: 10px 0;
  width: 140px;
  border: 1px solid gray;
  padding: 7px 20px;
  border-radius: 16px;
  margin-bottom: 30px;
  cursor: pointer;
  color: black;
  gap: 10px;
}

.language-selector img {
  margin-right: 5px;
}

.v-radio-group .v-radio {
  padding: 10px;
}

.language-option {
  display: flex;
  overflow: hidden;
  margin-top: 15px;
  align-items: center;
}
.container-lang {
  display: flex; gap: 20px; align-items: center;
  width: 90%;
  border-top: 1px solid #E7E8F0;
  border-bottom: 1px solid #E7E8F0;
  margin: 15px 0;
  padding: 0 30px;
}

.lang-ctn-line {
  height: 20px;
  border-left: 1px solid #7B7E8C;
}
.lang-ctn {
  cursor: pointer;
  height: 60px;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  gap: 10px;
}

.lang-ctn:hover {
  background-color: #f1f6ff;
  color: #162ca2;
  border-radius: 8px;
}

.active-submenu {
  background-color: #f1f6ff;
}

.sub-menu-header {
  padding: 16px;
  /* border-bottom: 1px solid #E7E8F0; */
}

.sub-menu-title {
  font-family: Poppins, sans-serif;
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 8px;
}

.sub-menu-description {
  font-family: Poppins, sans-serif;
  color: #666;
  font-size: 0.9em;
}

.sub-menu-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  padding: 16px;
}

.sub-menu-label {
  border-bottom: 2px solid black;
  width: fit-content;
  font-size: 0.9em;
  color: #888;
  font-weight: 500;
  margin-bottom: 4px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.submenu-program {
  font-weight: bold;
  font-size: 15px;
}

.sub-menu-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sub-menu-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.sub-menu-item:hover {
  background-color: #f5f5f5;
}
</style>